/***
 *
 *   STAT
 *   Statistic value with optional icon and -/+ change value.
 *
 *   DOCS
 *   https://docs.useMapMetrics Atlas.app/MapMetrics Atlas-web/components/stat
 *
 *   PROPS
 *   change: positive/negative number indicating change amount (integer, optional)
 *   className: custom styling (SCSS or tailwind style, optional)
 *   icon: icon (string, optional)
 *   label: value label (string, required)
 *   value: numeric value (integer or string, required)
 *
 **********/

import { Icon, useAPI } from "components/lib";
import { useEffect } from "react";
import { useState } from "react";

export function Stat({
  t,
  value,
  label,
  change,
  icon,
  className,
  stripeDetails,
}) {
  const changeUp = change?.toString().includes("-") ? false : true;

  const [keys, setKeys] = useState([]);

  // fetch
  const fetch = useAPI("/api/key");
  const subscriptionDetails = useAPI("/api/stripe/subscription-details");

  // init keys
  useEffect(() => {
    if (fetch?.data?.length) setKeys(fetch.data);
  }, [fetch]);
console.log(keys,'keys')
  return (
    <>
      <div className={className}>
        {label === "this month" ? (
          <header className="gap-6 bg-custom-radial text-right rounded-[10px] loading-normal overflow-hidden relative -m-10">
            <div className="bg-[#2E4C8980] p-3">
              <img
                src="/assets/globe.svg"
                alt="globe bg"
                className="absolute right-0 top-[-50%]"
              />
              <div className="relative">
                <div className="text-center mb-4">
                  <h2 className="text-white text-[26.531px] font-[800]">
                    $0.00
                  </h2>
                  <h4 className="text-white text-[18.87px] font-[500]">
                    {t("dashboard.widgets.title")}
                  </h4>
                </div>
                <div className="ml-auto inline-flex text-white font-bold bg-[#0C0E77] rounded-[5px] py-2 px-4">
                  {t("dashboard.widgets.expire.title")}:{" "}
                  {!subscriptionDetails.loading
                    ? new Date(
                        new Date(
                          subscriptionDetails?.data?.subscribed_at
                        ).getTime() + 2.628e9
                      ).toDateString()
                    : "Loading.."}
                </div>
              </div>
            </div>
          </header>
        ) : (
          <header className="flex items-center gap-6">
            <div
              className={`flex items-center justify-center w-[60px] h-[60px] rounded-[50%] glass-card dark:glass-card-dark backdrop-blur-lg border border-white/10 ${
                label === "Team members" || label === "Active Users"
                  ? "shadow-[0_0_20px_rgba(91,147,255,0.3)]"
                  : label === "API calls" || label === "API Requests"
                  ? "shadow-[0_0_20px_rgba(255,214,107,0.3)]"
                  : label === "Keys" || label === "Active Keys"
                  ? "shadow-[0_0_20px_rgba(255,143,107,0.3)]"
                  : "shadow-[0_0_20px_rgba(255,255,255,0.1)]"
              }`}
            >
              {icon && (
                <Icon
                  name={icon}
                  size={28}
                  className={`${
                    label === "Team members" || label === "Active Users"
                      ? "text-[#5B93FF]"
                      : label === "API calls" || label === "API Requests"
                      ? "text-[#FFD66B]"
                      : label === "Keys" || label === "Active Keys"
                      ? "text-[#FF8F6B]"
                      : "text-white/70"
                  } drop-shadow-lg`}
                />
              )}
            </div>
            <div>
              {value != undefined && (
                <div className="text-[24px] font-[600] text-white poppins-semibold tracking-wide">
                  {label === "Keys" || label === "Active Keys"
                    ? keys.length
                    : label === "API calls" || label === "API Requests"
                    ? stripeDetails?.data?.totalUsage?.toLocaleString() ||
                      "Loading.."
                    : value?.toLocaleString()}
                </div>
              )}
              {label && (
                <div className="text-[14px] font-[300] text-white/70 poppins-light tracking-wide">
                  {label === "Team members" ? "Active Users" :
                   label === "API calls" ? "API Requests" :
                   label === "Keys" ? "Active Keys" : 
                   t(label)}
                </div>
              )}
            </div>
          </header>
        )}
      </div>
    </>
  );
}
